// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/purchases-credit-memo-payments',
        component: () =>
            import(/* webpackChunkName: "accounts-payable.purchases-credit-memo-payments" */ '@/pages/[organisation]/payables/purchases-credit-memo-payments/purchases-credit-memo-payment/[id].vue'),
        name: 'accounts-payable.purchases-credit-memo-payments.view-purchases-credit-memo-payment',
        meta: {
            loginRequired: true,
            permission: 'purchases-credit-memo-payment.read',
        },
    },
];
